module.exports = __webpack_public_path__ + "static/media/troopr_full_logo.075b7775.svg";